// Helper to check the user's roles claim for an admin flag. See any admin view for sample usage.
import {User} from '@auth0/auth0-spa-js';

export const requireAdmin = (claims?: User) => (claims?.['https://equitymap.org/roles'] || []).includes('admin');
export const requireOrgAdmin = (claims?: User) => {
  return (claims?.['https://equitymap.org/roles'] || []).includes('org-admin');
};
